import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Alert,
  Link as MuiLink,
  Divider,
  Grid,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import authService from "../../services/auth.service";
import "../../styles/components.css";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    try {
      await authService.forgotPassword(email);
      setSuccess("Password reset instructions have been sent to your email");
      setEmail("");
    } catch (err) {
      setError(err.message || "Failed to process password reset request");
    }
  };

  return (
    <Box className="login-page-container">
      <Grid container height={"100vh"}>
        <Grid item xs={12} sm={12} md={5}>
          <div className="login-page-image-container" />
        </Grid>

        <Grid item xs={12} sm={12} md={7} className="login-page-right-panel">
          <Container className="right-panel-auth">
            <Box
              className="auth-box"
              sx={{
                maxWidth: isMobile ? "100%" : "85%",
              }}
            >
              <Typography className="auth-heading">
                Instant access to trading from comfort of your home
              </Typography>

              <Typography sx={{ my: 3, fontSize: 32, fontWeight: 700 }}>
                Forgot your password?
              </Typography>

              {error && (
                <Alert severity="error" sx={{ mb: 3 }}>
                  {error}
                </Alert>
              )}

              {success && (
                <Alert severity="success" sx={{ mb: 3 }}>
                  {success}
                </Alert>
              )}

              <Box
                component="form"
                onSubmit={handleSubmit}
                className="auth-form-box"
              >
                <Box mb={4.5}>
                  <Typography sx={{ fontSize: 24, fontWeight: 500 }}>
                    Email
                  </Typography>
                  <TextField
                    fullWidth
                    name="email"
                    type="email"
                    value={email}
                    onChange={handleChange}
                    required
                    variant="outlined"
                    hiddenLabel
                    sx={{
                      "& .MuiInputBase-input": {
                        padding: "20px 16px",
                        fontSize: "20px",
                      },
                    }}
                  />
                </Box>

                <Button
                  sx={{
                    mt: 3,
                  }}
                  type="submit"
                  fullWidth
                  variant="contained"
                  size="large"
                  className="button-primary"
                >
                  Send Email
                </Button>

                <Box className="auth-divider">
                  <Divider className="or-divider" />
                  <Typography variant="body2" className="auth-divider-text">
                    Or
                  </Typography>
                </Box>

                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    component="span"
                    sx={{ fontSize: 16, fontWeight: 400 }}
                  >
                    Already have an account?{" "}
                    <MuiLink
                      component={Link}
                      to="/login"
                      className="signup-link"
                    >
                      Sign In
                    </MuiLink>
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Container>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ForgotPassword;
